import { get } from '../../../infra/rest';
import { PlanApiResponse } from '../typings';

export const fetchCurrentPlan = async (): Promise<PlanApiResponse> => {
  return await get<PlanApiResponse>(`/v1/plan/features`, {}, true);
};
